import { useMemo, useState } from "react";
import classNames from "classnames";
import { buildClientSchema, IntrospectionQuery } from "graphql";

import Button from "~/components/shared/Button";
import Editor from "~/components/shared/GraphQLEditor/Editor";

type Props = {
  name: string;
  value: string;
  error: boolean;
  schema: IntrospectionQuery;
};

export default function (props: Props) {
  const [query, setQuery] = useState(props.value);

  const schema = useMemo(() => buildClientSchema(props.schema), [props.schema]);

  async function handlePrettify(event) {
    event.preventDefault();

    const formattedQuery = await import("~/lib/prettier").then((modules) =>
      modules.prettifyGraphqlQuery(query),
    );

    setQuery(formattedQuery);
  }

  return (
    <>
      <p className="mb-1 mt-0">
        For more detailed examples of common tasks, checkout the{" "}
        <a
          href="https://buildkite.com/docs/apis/graphql/graphql-cookbook"
          target="_blank"
          className="text-purple-600 hover:text-purple-600 hover:underline"
          rel="noreferrer"
        >
          GraphQL API cookbook
        </a>
        .
      </p>

      <div
        className={classNames("relative rounded-md border p-1", {
          "border-[#D0A9A7]": props.error,
          "border-[#ccc] focus-within:border-[#888]": !props.error,
        })}
      >
        <div className="overflow-x-auto">
          <Editor name={props.name} schema={schema} value={query} onChange={setQuery} />
        </div>

        <Button
          onClick={handlePrettify}
          className="absolute bottom-2 right-2 z-10 cursor-pointer"
          theme="small"
          type="button"
        >
          Prettier
        </Button>
      </div>
    </>
  );
}
